import useScrollReveal from '@/hooks/useScrollReveal';
import SectionHeading from '@/components/feature/SectionHeading';

const experiences = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Lokacija',
    text: 'Zamušani 2, tik ob glavni cesti — priročno za hitro kavo ali sproščen postanek med potjo.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/a8aec268cac0192721b3d5189e84d7be.png',
    imageAlt: 'Odprta prostorna notranjost lokala Guma Caffe Lounge Bar z izhodom na teraso',
    imageTitle: 'Prostorna notranjost Guma Caffe Lounge Bar Gorišnica z izhodom na teraso',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Druženje',
    text: 'Prostor za sproščene trenutke s prijatelji — od popoldanske kave do večernega druženja.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/75a073fda89801119f124fa751978880.png',
    imageAlt: 'Jägermeister in Coca-Cola v posodi z ledom, limeto in pomarančo',
    imageTitle: 'Druženje ob pijači v Guma Caffe Lounge Bar Zamušani',
  },
  {
    icon: 'ri-moon-clear-line',
    title: 'Vzdušje',
    text: 'Topla svetloba, prijetna glasba in domač občutek. Vsak del dneva ima na Gumi svoj čar.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/84c931a8e966565c42b5cec347d0f6fd.png',
    imageAlt: 'Ledeno hladne pijače Salitos v vedru z ledom in svežim sadjem',
    imageTitle: 'Večerno vzdušje in pijača v Guma Caffe Lounge Bar Gorišnica',
  },
];

export default function ExperienceSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="dozivetje" className="relative py-16 md:py-24 px-4 md:px-6 bg-background-50 scroll-mt-16 md:scroll-mt-20" ref={ref}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <SectionHeading
          eyebrow="Doživetje"
          title="Več kot samo kava."
          description="Trije razlogi, zakaj je Guma Bar prava izbira za tvoj naslednji obisk."
        />

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7">
          {experiences.map((exp, idx) => (
            <article
              key={idx}
              className={`group relative overflow-hidden rounded-lg p-7 md:p-9 min-h-[280px] md:min-h-[300px] flex flex-col justify-end transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${200 + idx * 150}ms` }}
            >
              <img
                src={exp.image}
                alt={exp.imageAlt}
                title={exp.imageTitle}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/45 to-black/20"></div>

              <div className="relative z-10">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-foreground-50/10 group-hover:bg-foreground-50/20 mb-5 md:mb-7 transition-colors duration-300">
                  <i className={`${exp.icon} text-foreground-50 text-xl md:text-2xl`}></i>
                </div>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-50 font-light mb-3 drop-shadow-md">
                  {exp.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-50/80 leading-relaxed drop-shadow-sm">
                  {exp.text}
                </p>
              </div>

              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-accent-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}